import React from "react";
import { useTranslation } from "react-i18next";

import styles from "../HomePage.module.css";

type ResendState = "idle" | "sending" | "sent" | "blocked";

type VerifyEmailBannerProps = {
	email: string;
	onResend: () => void;
	resendError: string;
	resendState: ResendState;
};

const VerifyEmailBanner = ({ email, onResend, resendError, resendState }: VerifyEmailBannerProps) => {
	const { t } = useTranslation("homePage");
	let buttonText = t("verification.resend");

	if (resendState === "sent") {
		buttonText = t("verification.sent");
	} else if (resendState === "sending") {
		buttonText = t("verification.sending");
	}

	return (
		<div className={styles.verifyBanner} role="status">
			<div className={styles.verifyText}>
				<span className={styles.verifyTitle}>{t("verification.title")}</span>
				<span className={styles.verifyMessage}>{t("verification.message", { email })}</span>
				{/* The API caps resends per day; show its message so the user knows when to try again. */}
				{resendError && <span className={styles.verifyError}>{resendError}</span>}
			</div>
			<button className={styles.verifyButton} disabled={resendState !== "idle"} onClick={onResend} type="button">
				{buttonText}
			</button>
		</div>
	);
};

export default VerifyEmailBanner;
